import React from 'react';
import { Typography, Select, MenuItem, SxProps, TypographyVariant, SelectChangeEvent } from '@mui/material';

interface SelectBoxProps {
    label?: string;
    labelSize?: TypographyVariant;
    name: string;
    value?: string | number;
    onChange?: (event: SelectChangeEvent<any>) => void;
    options: { value: string | number; label: string }[];
    sx?: SxProps;
    required?: boolean;
    className?: string;
    disabled?: boolean;
}

const SelectBox: React.FC<SelectBoxProps> = ({
    label,
    labelSize = 'h6',
    name,
    value,
    onChange,
    options,
    sx = {},
    required = false,
    className = '',
    disabled = false
}) => (
    <>
        <Typography variant={labelSize} align="left" gutterBottom>
            {label}
            {required && <span style={{ color: 'red' }}>*</span>}
        </Typography>
        <Select
            labelId={`${name}-label`}
            name={name}
            value={options.some(option => option.value === value) ? value : ""}
            onChange={onChange}
            sx={{ mb: 2, ...sx }}
            displayEmpty
            fullWidth
            size="small"
            className={className}
            disabled={disabled}
        >
            <MenuItem value="">Please select</MenuItem>
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </Select>

    </>
);

export default SelectBox;
